export default function (page, size) {
  return {
    page: page || 1,
    size: size || 10,
  }
}
